import { Collapse, Divider, message, Modal, Space, Spin } from "antd";
import { PlusIcon } from "../../admin/Icons";
import Overlay from "../Overlay";
import wrap from "../../utils/wrap";
import { usePrefs } from "../../utils/Prefs";
import Save from "../Save";
import Colour from "./Colour";
import { useState } from "react";
import conditional from "../../utils/conditional";
import Gradient from "./Gradient";

export default function Colours(props) {

    const [prefs, setPrefs] = usePrefs();
    const { templates = [], data = {}, setData = () => { }, changed = false, view = "" } = props;
    const { colours = [], gradients = [] } = data;


    const _unnamed_colour = {
        name: "Unnamed Colour",
        red: 240,
        green: 240,
        blue: 240,
        alpha: 1,
        style: "rgba(240,240,240,1)"
    }

    const _unnamed_gradient = {
        name: "Unnamed Gradient",
        style: "linear-gradient(0deg,rgba(0, 0, 0, 0) 0%,rgba(0, 0, 0, 0) 100%)",
        points: [{ left: 0, red: 0, green: 0, blue: 0, alpha: 0 }, { left: 100, red: 0, green: 0, blue: 0, alpha: 0 }],
        degree: 0,
        type: "linear"
    }

    // Save or Edit
    const save = (_data, _is_new = false, _is_gradient) => {



        let _key = (_is_gradient) ? "gradients" : "colours";
        if (_is_new) {
            if (_is_gradient) {
                // Even records for gradients
                _data.id = ((gradients.length + 1) * 2);
            } else {
                // Odd records for colours
                _data.id = ((colours.length + 1) * 2) - 1;
            }
        }

        let _arr = (_is_gradient) ? [...gradients] : [...colours];

        if (_is_new) {
            _arr.push(_data);
            setData({ ...data, [_key]: _arr });
            setPrefs({ ...prefs, "changed": true });
            // callback();
            return;
        } else {
            let _index = _arr.findIndex(item => item.id == _data.id);
            if (_index > -1) {
                _arr[_index] = _data;
                setData({ ...data, [_key]: _arr });
                setPrefs({ ...prefs, "changed": true });
                // callback();
            } else {
                message.error("There was an error");
            }
        }
    }

    const reset = (_id, _is_gradient) => {
        Modal.confirm({
            title: "Reset?",
            onOk: () => {
                if (_is_gradient) {
                    let _gradients = [...gradients];
                    let _f = _gradients.findIndex(item => item.id === _id);
                    if (_f > -1) {
                        _gradients[_f] = { ..._unnamed_gradient, "id": _id }
                    } else {
                        message.error("There was an error.")
                    }
                    setData({ ...data, "gradients": _gradients });
                } else {
                    let _colours = [...colours];
                    let _f = _colours.findIndex(item => item.id === _id);
                    if (_f > -1) {
                        _colours[_f] = { ..._unnamed_colour, "id": _id }
                    } else {
                        message.error("There was an error.")
                    }
                    setData({ ...data, "colours": _colours });
                }
                setPrefs({ ...prefs, "changed": true });
            }
        })
    }

    const remove = (_id, _is_gradient) => {

        Modal.confirm({
            title: "Delete?",
            onOk: () => {
                if (_is_gradient) {
                    let _gradients = gradients.filter(item => item.id !== _id);
                    setData({ ...data, "gradients": _gradients });
                    setPrefs({ ...prefs, "changed": true });
                } else {
                    let _colours = colours.filter(item => item.id !== _id);
                    setData({ ...data, "colours": _colours });
                    setPrefs({ ...prefs, "changed": true });
                }
            }
        })
    }


    const drawHeader = () => {
        return (
            <div style={{ "alignItems": "center" }} className="float-flex">
                <Space size={0}>
                    <strong>Colours</strong>
                </Space>
            </div>
        )
    }

    const drawColours = () => {
        return (
            <div>

                <Collapse

                    onChange={(e) => setPrefs({ ...prefs, "color_index": e })}

                    accordion activeKey={prefs.color_index} className="subpanel" expandIcon={({ isActive }) => {
                        return (isActive) ? "-" : "+"
                    }} ghost>

                    {/* COLORS */}
                    <Collapse.Panel
                        extra={
                            <conditional.true value={(prefs.color_index === "1")}>
                                <div><Overlay width="320px" component={<Colour colours={colours} save={save} is_new />}><wrap.tags pointer color="#1890ff"><PlusIcon /> <small>New</small></wrap.tags></Overlay></div>
                            </conditional.true>
                        }
                        header={<div style={{ "color": "#e77e21", "fontSize": "11px" }}>SOLID COLOURS</div>}
                        key="1">
                        {colours.map(item => {
                            return <Colour templates={templates} template={data} type="color" colours={colours} key={item.id} changed={changed} save={save} reset={reset} remove={remove} data={item} />
                        })}

                    </Collapse.Panel>

                    {/* GRADIENTS */}
                    <Collapse.Panel
                        extra={
                            <conditional.true value={(prefs.color_index === "2")}>
                                <div><Overlay width="320px" component={<Gradient colours={gradients} is_gradient save={save} is_new />}><wrap.tags pointer color="#1890ff"><PlusIcon /> <small>New</small></wrap.tags></Overlay></div>
                            </conditional.true>
                        }
                        header={<div onClick={() => setPrefs({ ...prefs, "color_index": 2 })} style={{ "color": "#e77e21", "fontSize": "11px" }}>GRADIENTS</div>}
                        key="2">
                        {gradients.map(item => {

                            return <Gradient templates={templates} template={data} is_gradient={true} colours={gradients} key={item.id} changed={changed} save={save} reset={reset} remove={remove} data={item} />
                        })}

                    </Collapse.Panel>
                </Collapse>
                {/* <pre><small>{JSON.stringify(colours, null, 2)}</small></pre> */}
            </div>
        )
    }

    switch (view) {
        case "header":
            return drawHeader();
        default:
            return drawColours();
    }

}

